const TODAY_ISO = "2026-08-17";

const APP_LABELS = {
  "mobile-app": "Grid Profile",
  "ponto-app": "GridProfile Ponto",
};

const PRIVACY_POLICIES = {
  "mobile-app": {
    id: "mobile-app",
    app_name: "Grid Profile",
    product: "mobile_app",
    platforms: ["iOS", "Android"],
    contact_email: "cpd@neurosynx.com.br",
    website_url: "https://grid-profile.neurosynx.com.br",
    effective_date: TODAY_ISO,
    last_updated: TODAY_ISO,
    summary:
      "Politica de privacidade do aplicativo Grid Profile para registro de ponto, viagens, documentos e solicitacoes trabalhistas.",
    sections: [
      {
        title: "1. Escopo",
        content: [
          "Esta politica descreve como o Grid Profile trata dados pessoais quando voce usa o aplicativo movel da plataforma GridProfile.",
          "O aplicativo e destinado ao uso corporativo por colaboradores e prestadores vinculados as empresas clientes da plataforma.",
        ],
      },
      {
        title: "2. Dados coletados",
        content: [
          "Dados de identificacao e conta, como nome, e-mail corporativo, identificadores internos e vinculo com a empresa.",
          "Dados de ponto e jornada, como registros de entrada, saida, correcoes, abonos e justificativas enviadas pelo usuario.",
          "Dados de geolocalizacao precisa, inclusive em segundo plano quando o recurso de viagem estiver ativo, para validar rotas, deslocamentos e registros associados.",
          "Dados de camera, fotos e documentos quando o usuario realiza selfie, anexa comprovantes ou envia arquivos para processos internos.",
          "Dados tecnicos do dispositivo e do aplicativo, como identificadores de sessao, preferencias locais, tokens de notificacao e informacoes necessarias para seguranca e funcionamento.",
        ],
      },
      {
        title: "3. Finalidades de uso",
        content: [
          "Autenticar o usuario e liberar acesso aos recursos contratados pela empresa.",
          "Registrar ponto, controlar jornada, suportar aprovacoes, auditoria interna e comprovacao operacional das solicitacoes feitas no app.",
          "Registrar viagens e validar localizacao quando a funcionalidade de deslocamento estiver ativa e autorizada pelo usuario e pela empresa.",
          "Permitir anexos, selfies e documentos exigidos em fluxos de RH, DP e conformidade.",
          "Enviar notificacoes operacionais relacionadas ao uso do aplicativo, como avisos de jornada, viagens e eventos importantes.",
        ],
      },
      {
        title: "4. Compartilhamento de dados",
        content: [
          "Os dados podem ser compartilhados com a empresa a qual o usuario esta vinculado, dentro dos limites do contrato e das permissoes administrativas da plataforma.",
          "Podem ser utilizados prestadores de infraestrutura, armazenamento, mensageria e autenticacao estritamente para viabilizar o servico.",
          "Os dados tambem podem ser compartilhados quando houver obrigacao legal, regulatoria, ordem judicial ou necessidade de prevencao a fraude e abuso.",
        ],
      },
      {
        title: "5. Armazenamento, retencao e seguranca",
        content: [
          "Parte das informacoes pode ser armazenada localmente no dispositivo para permitir autenticacao, preferencias, cache operacional e funcionamento offline controlado.",
          "Os registros enviados ao sistema permanecem armazenados pelo periodo necessario para fins trabalhistas, operacionais, contratuais, legais e de auditoria.",
          "Sao adotadas medidas tecnicas e administrativas razoaveis para reduzir risco de acesso nao autorizado, alteracao indevida, perda ou destruicao dos dados.",
        ],
      },
      {
        title: "6. Permissoes sensiveis do aplicativo",
        content: [
          "Localizacao: usada para validar registros de jornada e monitorar deslocamentos quando os fluxos de viagem estiverem ativos.",
          "Localizacao em segundo plano: usada apenas durante cenarios operacionais que dependem de rastreio continuo de viagem.",
          "Camera e fotos: usadas para selfie, captura de comprovantes e anexos.",
          "Documentos e arquivos: usados para upload de comprovantes e arquivos enviados pelo proprio usuario.",
          "Notificacoes: usadas para alertas operacionais do aplicativo.",
        ],
      },
      {
        title: "7. Direitos do titular",
        content: [
          "O usuario pode solicitar esclarecimentos sobre tratamento de dados, atualizacao cadastral e analise de exclusao ou anonimização, observadas as obrigacoes legais e contratuais aplicaveis.",
          "Solicitacoes relacionadas a privacidade devem ser encaminhadas para o canal institucional informado nesta politica ou para a area responsavel da empresa contratante.",
        ],
      },
      {
        title: "8. Alteracoes desta politica",
        content: [
          "Esta politica pode ser atualizada para refletir mudancas legais, regulatorias, contratuais, tecnicas ou funcionais do aplicativo.",
          "A versao vigente estara sempre disponivel na pagina publica e no endpoint oficial de politica de privacidade do sistema.",
        ],
      },
    ],
  },
  "ponto-app": {
    id: "ponto-app",
    app_name: "GridProfile Ponto",
    product: "ponto_app",
    platforms: ["iOS", "Android"],
    contact_email: "cpd@neurosynx.com.br",
    website_url: "https://grid-profile.neurosynx.com.br",
    effective_date: TODAY_ISO,
    last_updated: TODAY_ISO,
    summary:
      "Politica de privacidade do aplicativo GridProfile Ponto para marcacao de ponto com selfie, localizacao e autenticacao operacional.",
    sections: [
      {
        title: "1. Escopo",
        content: [
          "Esta politica descreve como o GridProfile Ponto trata dados pessoais quando o usuario utiliza o aplicativo de marcacao de jornada.",
          "O aplicativo e voltado ao registro de ponto corporativo e ao cumprimento de regras operacionais definidas pela empresa contratante.",
        ],
      },
      {
        title: "2. Dados coletados",
        content: [
          "Dados de identificacao e vinculo funcional, como nome, identificadores internos e informacoes necessarias para autenticacao e associacao do registro ao colaborador correto.",
          "Dados de ponto e jornada, incluindo horario do registro, status da marcacao, observacoes operacionais e historico de uso do recurso.",
          "Dados de geolocalizacao precisa coletados no momento do registro para validacao do ponto conforme regras da empresa.",
          "Dados de camera e selfie quando o fluxo exigir comprovacao visual do usuario no ato da marcacao.",
          "Dados de autenticacao operacional e seguranca, incluindo PIN, informacoes de sessao e dados minimos do dispositivo necessarios para prevenir uso indevido.",
        ],
      },
      {
        title: "3. Finalidades de uso",
        content: [
          "Registrar ponto de entrada, saida e eventos correlatos com identificacao confiavel do colaborador.",
          "Validar presenca, localizacao e consistencia operacional da marcacao conforme regras definidas pela empresa.",
          "Apoiar auditoria, prevencao a fraude, analise administrativa e gestao da jornada de trabalho.",
          "Manter o funcionamento tecnico do aplicativo, autenticacao do usuario e seguranca da conta.",
        ],
      },
      {
        title: "4. Compartilhamento de dados",
        content: [
          "Os dados podem ser compartilhados com a empresa contratante para gestao de jornada, auditoria, RH, DP e conformidade interna.",
          "Podem ser utilizados servicos de infraestrutura e armazenamento estritamente necessarios para o processamento das marcacoes.",
          "Os dados poderao ser fornecidos em caso de obrigacao legal, regulatoria, judicial ou para apuracao de fraude e incidentes de seguranca.",
        ],
      },
      {
        title: "5. Retencao e seguranca",
        content: [
          "As marcacoes e evidencias associadas podem ser mantidas pelo prazo necessario para atender obrigacoes legais, trabalhistas, contratuais e de auditoria.",
          "Dados locais podem ser temporariamente mantidos no dispositivo para autenticacao, estabilidade do app e sincronizacao controlada.",
          "Sao adotadas medidas razoaveis de seguranca para proteger os dados contra acesso nao autorizado e uso indevido.",
        ],
      },
      {
        title: "6. Permissoes do aplicativo",
        content: [
          "Localizacao: usada para validar o ponto no momento do registro.",
          "Camera: usada para selfie e comprovacao visual quando exigida.",
          "Armazenamento e arquivos: usados apenas se houver necessidade de selecionar ou persistir dados operacionais locais do aplicativo.",
        ],
      },
      {
        title: "7. Direitos e contato",
        content: [
          "Solicitacoes relacionadas a privacidade, atualizacao cadastral e duvidas sobre o tratamento dos dados podem ser encaminhadas ao contato institucional informado nesta politica.",
          "Pedidos de exclusao ou restricao serao avaliados conforme obrigacoes legais, trabalhistas e contratuais aplicaveis ao servico.",
        ],
      },
      {
        title: "8. Atualizacoes",
        content: [
          "Esta politica podera ser alterada para refletir mudancas legais, regulatorias ou funcionais do aplicativo.",
          "A versao mais recente sera publicada na pagina publica do sistema e no endpoint oficial da API.",
        ],
      },
    ],
  },
};

export const getPrivacyPolicyApiBase = () =>
  (process.env.REACT_APP_BACKEND_URL || "").replace(/\/$/, "");

export const getPolicyPublicBase = () =>
  (process.env.REACT_APP_BASE_URL || window.location.origin).replace(/\/$/, "");

export const getFallbackPolicy = (policyId) => {
  const policy = PRIVACY_POLICIES[policyId];
  if (!policy) return null;

  const publicBase = getPolicyPublicBase();
  const apiBase = getPrivacyPolicyApiBase();
  const pagePath = `/politica-de-privacidade/${policyId}`;

  return {
    ...policy,
    page_path: pagePath,
    page_url: `${publicBase}${pagePath}`,
    api_url: `${apiBase}/api/public/privacy-policies/${policyId}` || `/api/public/privacy-policies/${policyId}`,
  };
};

export const listFallbackPolicies = () =>
  Object.keys(PRIVACY_POLICIES).map((policyId) => getFallbackPolicy(policyId));

export const getAppLabel = (policyId) => APP_LABELS[policyId] || policyId;
